
export interface CommonResponse {
  code?: string;
  message?: string;
  success?: boolean;
}
